<template>
  <div id="square-button-wrapper" ref="square-button-wrapper">
    <button
      class="rounded-button"
      @click="roundedButtonClicked"
      ref="square-button"
      :disabled="disabled"
    >
      {{ $t(text) }}
    </button>
  </div>
</template>

<script>
import createRipple from "@/assets/js/rippleEffect.js";
export default {
  name: "RoundedButton",
  props: {
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: "200px"
    },
    height: {
      type: String,
      required: false,
      default: "35px"
    },
    buttonType: {
      type: String,
      required: false,
      default: "primary"
    },
    position: {
      type: String,
      required: false,
      default: "leftAlign"
    }
  },
  mounted() {
    this.$refs["square-button-wrapper"].style.height = this.height;
    this.$refs["square-button-wrapper"].style.width = this.width;
    this.$refs["square-button-wrapper"].classList.add(this.position);
    this.changeButtonDisabledStyle();
  },
  methods: {
    roundedButtonClicked(event) {
      createRipple(event);
      this.$emit("click");
    },
    changeButtonDisabledStyle() {
      if (!this.disabled) {
        this.$refs["square-button"].classList.remove("disabled");
        this.$refs["square-button"].classList.add(this.buttonType);
      } else {
        this.$refs["square-button"].classList.remove(this.buttonType);
        this.$refs["square-button"].classList.add("disabled");
      }
    }
  },
  watch: {
    disabled() {
      this.changeButtonDisabledStyle();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#square-button-wrapper {
  .rounded-button {
    width: 100%;
    height: 100%;
    outline: none;
    border-radius: 10px;
    color: white;
    position: relative;
    overflow: hidden;
    transition: background 800ms;
  }
  .primary {
    border: 1px solid $color-primary;
    background: $color-light-primary;
    &:hover {
      box-shadow: $input-shadow;
      background: $color-primary;
    }
  }
  .danger {
    border: 1px solid $color-danger;
    background: $color-light-danger;
    &:hover {
      box-shadow: $input-shadow;
      background: $color-danger;
    }
  }
  .disabled {
    border: 1px solid $color-disabled;
    background: $color-disabled;
  }
}
.centerAlign {
  margin-left: auto;
  margin-right: auto;
}
.rightAlign {
  margin-left: auto;
  margin-right: 0;
}
.leftAlign {
  margin-left: 0;
  margin-right: auto;
}
</style>
